export const objectTypedKeys = Object.keys as <T extends object>(obj: T) => Array<keyof T>;
export const objectTypedValues = Object.values as <T extends object>(obj: T) => Array<T[keyof T]>;
export const objectTypedEntries = Object.entries as <T extends object>(obj: T) => Array<[keyof T, T[keyof T]]>;
